import { FEED_COUNT, RECENT_WALL_COUNT, ROI_VALUE_UPDATE, POST_THIS_WEEK, SOCIAL, DASHBOARD_WALL_LOADER, GET_RECENT_POST_DATA, RECENT_POST_LOADER, VISITOR_CLICKS_DATA, GET_WALL_SENTIMENT_LIVE_TREND_DASHBOARD_DATA, MOST_ACTIVE_USERS_DASHBOARD, MOST_ACTIVE_USERS_DASHBOARD_LOADER, WALL_SENTIMENT_LIVE_DASHBOARD_LOADER, VISITOR_CLICKS_LOADER, SOCIAL_LOADER } from '../keys'
const initialState = { dashboarddata: null, recent_data: null, post_week: null, social_loader : false, visitor_clicks_loader : false, sentiment_live_loader : false, most_active_user_loader: false, dashboard_wall_loader: false, most_active_user_data:[], sentiment_live_trend_data : [],  visitor_clicks_data:[], recent_post_data:[], socail_data: null, recent_post_loader : false, recent_post : [] }
export default function reducer(state = initialState, action) {

    switch (action.type) {

        case DASHBOARD_WALL_LOADER: {
            return { ...state, dashboard_wall_loader: action.payload }
        }
        case FEED_COUNT: {
            return { ...state, dashboarddata: action.payload, dashboard_wall_loader : false }
        }

        case MOST_ACTIVE_USERS_DASHBOARD_LOADER: {
            return { ...state, most_active_user_loader: action.payload }
        }
         case MOST_ACTIVE_USERS_DASHBOARD: {
            return { ...state, most_active_user_data: action.payload, most_active_user_loader : false }
        }

        case WALL_SENTIMENT_LIVE_DASHBOARD_LOADER: {
            return { ...state, sentiment_live_loader: action.payload }
        }
        case GET_WALL_SENTIMENT_LIVE_TREND_DASHBOARD_DATA: {
            return { ...state, sentiment_live_trend_data: action.payload, sentiment_live_loader : false }
        }

        case GET_RECENT_POST_DATA: {
            return { ...state, recent_post_data: action.payload, recent_post_loader : false }
        }
        case RECENT_POST_LOADER: {
            return { ...state, recent_post_loader : action.payload }
        }
        case RECENT_WALL_COUNT: {
            return { ...state, recent_data: action.payload }
        }
        

        case SOCIAL_LOADER: {
            return { ...state, social_loader: action.payload }
        }
        case SOCIAL: {
            return { ...state, socail_data: action.payload, social_loader : false }
        }


        case VISITOR_CLICKS_LOADER: {
            return { ...state, visitor_clicks_loader: action.payload }
        }
        case VISITOR_CLICKS_DATA: {
            return { ...state, visitor_clicks_data: action.payload, visitor_clicks_loader : false }
        }

        case POST_THIS_WEEK: {
            return { ...state, post_week: action.payload }
        }
    

        case ROI_VALUE_UPDATE: {
            var updateData = state.dashboarddata
            if (updateData && Object.keys(updateData).length > 0) {
                if (updateData.roi_calculator && Object.keys(updateData.roi_calculator).length > 0) {
                    updateData.roi_calculator.estimated_value = action.payload

                }


            }
            return { ...state, dashboarddata: updateData }
        }
        default:

            return { ...state }
    }

}